import React, { useContext, useEffect, useState } from 'react';
import CreatableSelect from 'react-select/creatable';
import { Context } from "../../state/context";

export default function TagsSelect({ selectedItems, showLabel, onChange, onSave, hasPlatformTags, isMandatory }) {
    const { state } = useContext(Context);

    const [tagsOptions, setTagsOptions] = useState(false);
    const [tags, setTags] = useState(false);
    const [showSave, setShowSave] = useState(false);

    useEffect(() => {
        setTags(selectedItems);
    }, [selectedItems]);

    useEffect(() => {
        const options = hasPlatformTags ? state.platformTags : state.tags;
        const opt = options.map((tag) => {
            return {
                value: tag.id,
                label: tag.name
            };
        });
        setTagsOptions(opt);
    }, [state.tags, state.platformTags]);

    const handleChange = (values) => {
        if (!showSave) setShowSave(true);
        if (!values) values = [];
        onChange(values);
    }

    const handleSave = () => {
        const response = onSave();
        if (response) {
            setShowSave(false);
        }
    }
    const widgetTitle = hasPlatformTags ? 'Add platform tags' : 'Add tags';
    const requireLabel = isMandatory ? <span className="text-danger">*</span> : null;
    return (
        <div className={`${onSave ? 'mb-4' : ''}`}>
            <div className={`${!onSave ? ((showLabel) ? 'mb-2' : '') : ''}`}>
                {showLabel && <h6 className='translation-section-title text-muted'>{widgetTitle}{requireLabel}</h6>}
                {(tags && tagsOptions) && <CreatableSelect className="cursor-pointer" closeMenuOnSelect={false} isMulti options={tagsOptions} backspaceRemovesValue={false} defaultValue={tags} onChange={handleChange} />}
            </div>
            {onSave && <button className={`btn btn-mondly btn-blue mt-2 ${showSave ? '' : 'transparent'}`} disabled={!showSave} onClick={handleSave}>Save</button>}
        </div>
    )
}
